export const UPDATE_TEXT_INPUT = 'UPDATE_TEXT_INPUT';
export const UPDATE_COLUMN_TEXT_INPUT = 'UPDATE_COLUMN_TEXT_INPUT';
export const CHANGE_PROFILE_STATUS = 'CHANGE_PROFILE_STATUS';
export const UNLOCK_AUDIO_DIALOG_SHOWN = 'UNLOCK_AUDIO_DIALOG_SHOWN';
export const UNLOCK_SAMPLE_DIALOG_SHOWN = 'UNLOCK_SAMPLE_DIALOG_SHOWN';
export const SHOW_SAMPLE_UNLOCK_DIALOG = 'SHOW_SAMPLE_UNLOCK_DIALOG';
export const SET_SELECTION_ITEM_ELEMENT = 'Web.TemplatesInterface.v1_0.Touch.DialogTemplateInterface.SetSelectorItemElementMethod';
